// Copyright (c) Docugami, Inc. All rights reserved.

import { useMemo } from "react";
import { createExampleChunksByDocsetLabelSelector } from "store/frontend/selectors";
import { useAppSelector } from "./redux";
import { ExampleChunk, useGetExampleChunksQuery } from "store/frontend/frontendSlice";
import { skipToken } from "@reduxjs/toolkit/dist/query";
import { selectClusterId } from "store/reports/selectors";

export interface ExampleChunksForLabel {
    exampleChunks: ExampleChunk[];
    isLoading: boolean;
}

export const useExampleChunksForLabel = (label: string, includeText: boolean, skip?: boolean): ExampleChunksForLabel => {
    const clusterId = useAppSelector(selectClusterId);
    const { isLoading } = useGetExampleChunksQuery(!skip ? {docsetId: clusterId, includeText: includeText} : skipToken);
    const exampleChunksSelector = useMemo(() => createExampleChunksByDocsetLabelSelector(clusterId, label, includeText), [clusterId, label, includeText]);
    const exampleChunks = useAppSelector(state => exampleChunksSelector(state));
    return {
        exampleChunks: exampleChunks,
        isLoading: isLoading
    }
}
